module.exports = __webpack_public_path__ + "img/02.b6f81ec1.jpg";